// Module
var code = "<div class=\"container\"> <div class=\"row\"> <div class=\"SSOError\"> <h4 class=\"SSOError__title\">Hmm. We're having trouble signing you in.</h4> Please try again. If you continue to have problems, give us a call. We're happy to help. </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/sso/ssoError.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;